import { defaultSettings } from 'src/components/settings';



export const schemeConfig = {
  modeStorageKey: 'theme-mode',
  defaultMode: defaultSettings.colorScheme,
  colorSchemeSelector: 'data-mui-color-scheme',
};
